// Internal
import { isNullOrUndefined } from "../functions/general.jsx";

function getInputContainerClass(containerClass, value, focused, errorMessage) {
    const classDetails = getInputClassDetails(value, errorMessage);

    if (containerClass) {
        return containerClass + " " + classDetails
    } else if (focused) {
        return "eone-ui-input-container eone-ui-input-container-focused " + classDetails;
    } else {
        return "eone-ui-input-container " + classDetails;
    }
}

function getSelectInputFilledOrEmptyClass(value, multiSelect) {
    if (!multiSelect) {
        return getInputFilledOrEmptyClass(value);
    }

    return value?.length > 0 ? "filled" : "empty";
}

function getInputFilledOrEmptyClass(value) {
    return isNullOrUndefined(value) || value === "" ? "empty" : "filled";
}

function getInputErrorClass(errorMessage) {
    return isNullOrUndefined(errorMessage) || errorMessage === "" ? "" : "error";
}

function getInputClassDetails(value, errorMessage) {
    const filledOrEmpty = getInputFilledOrEmptyClass(value);
    const error = getInputErrorClass(errorMessage);
    return filledOrEmpty + " " + error;
}

export { getInputContainerClass, getSelectInputFilledOrEmptyClass, getInputFilledOrEmptyClass, getInputErrorClass, getInputClassDetails }